import React from 'react';
import Lottie from 'react-lottie';
import './Save_Upto_Lottie.css';
import * as animationData from './Save_Upto_Lottie.json';

function Save_Upto_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Save_Upto_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Save_Upto_Lottie;